import RfiAnalyticsUploader from './RfiAnalyticsUploader.component';

export default RfiAnalyticsUploader;